import React, { FC, ReactNode } from "react";
import { AppPageLayout } from "./AppPageLayout";
import { AppPageLayoutContext } from "./AppPageLayoutContext";

export interface AppPageLayoutProviderProps {
  value: AppPageLayout;
  children: ReactNode;
}

export const AppPageLayoutProvider: FC<AppPageLayoutProviderProps> = (
  props
) => {
  return (
    <AppPageLayoutContext.Provider value={props.value}>
      {props.children}
    </AppPageLayoutContext.Provider>
  );
};
